(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-banner"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('b4u-slider')) {

  customElements.define(
    'b4u-slider',

    class extends HTMLElement {

      connectedCallback() {

        this.track =
          this.querySelector(
            '.b4u-hero__track'
          );

        this.designMode =
          this.dataset.designMode === 'true';

        this.reduceMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        this.applySchedule();

        this.slides =
          Array.from(
            this.track.children
          );

        if (!this.slides.length) {

          this.hidden = true;

          return;
        }

        this.buildDots();

        this.bindArrows();

        this.track.addEventListener(
          'scroll',
          () => this.onScroll(),
          { passive: true }
        );

        this.setupAutoplay();

        if (this.designMode) {

          this.bindEditor();

        }

      }


      /* =====================================================
         SCHEDULE
         ===================================================== */

         applySchedule() {

  const now = new Date();

  Array
    .from(this.track.children)
    .forEach((slide) => {

      const date =
        slide.dataset.scheduledDate;

      const time =
        slide.dataset.scheduledTime;

      const hideDate =
        slide.dataset.hideDate;

      const hideTime =
        slide.dataset.hideTime;


      /*
       * Convert a UK date/time into a real Date.
       * Uses Europe/London so GMT/BST is handled automatically.
       */
      const ukDateToDate = (dateString, timeString) => {

        if (!dateString || !timeString) {
          return null;
        }

        if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
          return null;
        }

        if (!/^\d{2}:\d{2}$/.test(timeString)) {
          return null;
        }

        const [year, month, day] =
          dateString.split('-').map(Number);

        const [hour, minute] =
          timeString.split(':').map(Number);


        /*
         * First create a UTC guess.
         */
        const guess =
          new Date(
            Date.UTC(
              year,
              month - 1,
              day,
              hour,
              minute
            )
          );


        /*
         * Find London's actual offset on that date.
         */
        const parts =
          new Intl.DateTimeFormat(
            'en-GB',
            {
              timeZone: 'Europe/London',
              timeZoneName: 'longOffset'
            }
          ).formatToParts(guess);

        const offsetPart =
          parts.find(
            part =>
              part.type === 'timeZoneName'
          );

        const offset =
          offsetPart
            ? offsetPart.value
            : 'GMT';


        /*
         * GMT = UTC
         */
        if (offset === 'GMT') {
          return guess;
        }


        /*
         * BST = UTC+1
         */
        if (offset === 'GMT+01:00') {

          return new Date(
            guess.getTime() - (60 * 60 * 1000)
          );

        }


        return guess;

      };


      /*
       * ================================
       * SHOW FROM
       * ================================
       */

      if (date && time) {

        const scheduledDate =
          ukDateToDate(
            date,
            time
          );

        if (
          scheduledDate &&
          now < scheduledDate
        ) {

          slide.remove();

          return;

        }

      }


      /*
       * ================================
       * HIDE AFTER
       * ================================
       */

      if (hideDate && hideTime) {

        const hideAt =
          ukDateToDate(
            hideDate,
            hideTime
          );

        if (
          hideAt &&
          now >= hideAt
        ) {

          slide.remove();

          return;

        }

      }

    });

}



      /* =====================================================
         DOTS
         ===================================================== */

      buildDots() {

        this.dotsWrap =
          this.querySelector(
            '.b4u-hero__dots'
          );

        this.dotsWrap.innerHTML = '';

        if (this.slides.length < 2) {

          this
            .querySelectorAll(
              '.b4u-hero__arrow'
            )
            .forEach(
              (a) =>
                a.hidden = true
            );

          return;
        }

        this.dots =
          this.slides.map(
            (slide, i) => {

              slide.setAttribute(
                'aria-label',
                (i + 1) +
                ' of ' +
                this.slides.length
              );

              const dot =
                document.createElement(
                  'button'
                );

              dot.type = 'button';

              dot.className =
                'b4u-hero__dot';

              dot.setAttribute(
                'aria-label',
                'Show slide ' +
                (i + 1)
              );

              dot.addEventListener(
                'click',
                () => {

                  this.goTo(i);

                  this.restart();

                }
              );

              this.dotsWrap.appendChild(
                dot
              );

              return dot;

            }
          );

        this.index = 0;

        this.updateDots();

      }


      /* =====================================================
         ARROWS
         ===================================================== */

      bindArrows() {

        const prev =
          this.querySelector(
            '.b4u-hero__arrow--prev'
          );

        const next =
          this.querySelector(
            '.b4u-hero__arrow--next'
          );

        if (prev) {

          prev.addEventListener(
            'click',
            () => {

              this.goTo(
                this.index - 1
              );

              this.restart();

            }
          );

        }

        if (next) {

          next.addEventListener(
            'click',
            () => {

              this.goTo(
                this.index + 1
              );

              this.restart();

            }
          );

        }

      }


      /* =====================================================
         GO TO
         ===================================================== */

      goTo(i) {

        const n =
          this.slides.length;

        this.index =
          (i + n) % n;

        this.track.scrollTo({

          left:
            this.index *
            this.track.clientWidth,

          behavior:
            this.reduceMotion
              ? 'auto'
              : 'smooth'

        });

        this.updateDots();

      }


      /* =====================================================
         SCROLL
         ===================================================== */

      onScroll() {

        const i =
          Math.round(
            this.track.scrollLeft /
            this.track.clientWidth
          );

        if (i !== this.index) {

          this.index = i;

          this.updateDots();

        }

      }


      /* =====================================================
         DOTS
         ===================================================== */

      updateDots() {

        if (!this.dots) return;

        this.dots.forEach(
          (d, i) => {

            d.setAttribute(
              'aria-current',

              i === this.index
                ? 'true'
                : 'false'
            );

          }
        );

      }


      /* =====================================================
         AUTOPLAY
         ===================================================== */

      setupAutoplay() {

        this.autoplay =
          this.dataset.autoplay === 'true' &&
          !this.reduceMotion &&
          !this.designMode &&
          this.slides.length > 1;

        this.speed =
          (
            parseInt(
              this.dataset.speed,
              10
            ) || 6
          ) * 1000;

        if (!this.autoplay) return;

        const pause =
          () => this.stop();

        const play =
          () => this.start();

        this.addEventListener(
          'mouseenter',
          pause
        );

        this.addEventListener(
          'mouseleave',
          play
        );

        this.addEventListener(
          'focusin',
          pause
        );

        this.addEventListener(
          'focusout',
          play
        );

        this.track.addEventListener(
          'touchstart',
          pause,
          { passive: true }
        );

        document.addEventListener(
          'visibilitychange',
          () =>
            document.hidden
              ? pause()
              : play()
        );

        this.start();

      }


      start() {

        if (!this.autoplay) return;

        this.stop();

        this.timer =
          setInterval(
            () =>
              this.goTo(
                this.index + 1
              ),
            this.speed
          );

      }


      stop() {

        clearInterval(
          this.timer
        );

      }


      restart() {

        this.start();

      }


      /* =====================================================
         SHOPIFY THEME EDITOR
         ===================================================== */

      bindEditor() {

        document.addEventListener(
          'shopify:block:select',
          (e) => {

            const i =
              this.slides.findIndex(
                (s) =>
                  s.dataset.blockId ===
                  e.detail.blockId
              );

            if (i > -1) {

              this.goTo(i);

            }

          }
        );

      }


      disconnectedCallback() {

        this.stop();

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();
})();
